<div class="flex flex-col items-center bg-gray-100 dark:bg-gray-900 p-0 sm:p-8  rounded-2xl shadow-xl mx-auto">

  <!-- Foto do Usuário -->
  <ui-photo [id]="avatarId" *ngIf="avatar" (valueChange)="onPhotoChange($event, true)"
    (valueDeleted)="onPhotoDelete($event)" [size]="EComponentSize.ExtraLarge" [isCircular]="true" [editable]="editable"
    [imageUrl]="avatar.path">
  </ui-photo>

  <br>

  <!-- Título -->
  <ui-label [tag]="ELabelTypes.TITLE" [clickable]="false" [type]="EAlert.DARK">
    Perfil do Usuário
  </ui-label>
  <ui-label [tag]="ELabelTypes.PARAGRAPH" [clickable]="false" [type]="EAlert.DARK">
    Aqui você pode visualizar e editar suas informações pessoais. Mantenha seu perfil atualizado para aproveitar ao
    máximo sua experiência. Adicione uma foto, revise seus dados e personalize suas preferências!
  </ui-label>

  <div class="w-full mt-2 relative">
    <ui-button [size]="EComponentSize.Large" [type]="EAlert.DARK" class="absolute top-5 right-0"
      (action)="toggleEditable()" [icon]="!editable ? EIcon.Edit : EIcon.Close"></ui-button>
    <ui-dynamic-form *ngIf="currentFields.length > 0" (valueChange)="onFormSubmit($event)" [withBorder]="false"
      [useSteps]="false" [inList]="false" [finalSubmit]="'Atualizar'" [showButtons]="editable" [fields]="currentFields">
    </ui-dynamic-form>
  </div>

  <div class="w-full mt-6 p-4 border border-gray-400 dark:border-gray-700 bg-white dark:bg-gray-800 rounded-lg relative">
    <ui-label [tag]="ELabelTypes.SECTION_TITLE" [clickable]="false" [type]="EAlert.DARK">
      Fotos
    </ui-label>
    <div class="absolute top-3 right-4 cursor-pointer transform hover:rotate-180 transition-transform duration-300">
      <ui-button [size]="EComponentSize.Large" [type]="EAlert.DARK"[icon]="EIcon.Synchronize"
      (action)="userPhotos()"></ui-button>
    </div>

    <div *ngIf="files.length > 0; else emptyState" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      <div *ngFor="let file of files" class="flex justify-center">
        <ui-photo [imageUrl]="file.path ?? ''" [id]="getFileId(file)"
          [size]="EComponentSize.ExtraLarge" [isCircular]="false" [editable]="true" [excludable]="true"
          (valueChange)="onPhotoChange($event, false)" (valueDeleted)="onPhotoDelete($event)">
        </ui-photo>
      </div>
    </div>
    
    <ng-template #emptyState>
      <div class="flex flex-col items-center justify-center p-6 rounded-lg">
        <ui-icon [icon]="EIcon.Image" [size]="EComponentSize.ExtraLarge" [color]="EAlert.DARK"></ui-icon>
        <ui-label [tag]="ELabelTypes.PARAGRAPH" [clickable]="false" [type]="EAlert.DARK">
          Nenhuma foto adicionada ainda
        </ui-label>
        <ui-label [tag]="ELabelTypes.PARAGRAPH" [clickable]="false" [type]="EAlert.DARK">
          Clique abaixo para enviar suas primeiras imagens.
        </ui-label>
      </div>
    </ng-template>

    <div class="w-full mt-4">
      <ui-image-uploader (imagesUploaded)="onImagesUpload($event)" [title]="'Carregar Imagens'"></ui-image-uploader>
    </div>
  </div>

</div>